import AccountingPage from "@/pages/superadmin/accounting/AccountingPage";
import ActiveSpacesPage from "@/pages/superadmin/spaces/ActiveSpacesPage";
import BookingsPage from "@/pages/superadmin/bookings/BookingsPage";
import CreatedSpacesPage from "@/pages/superadmin/spaces/CreatedSpacesPage";
import PendingSpacesPage from "@/pages/superadmin/spaces/PendingSpacesPage";
import RejectedSpacesPage from "@/pages/superadmin/spaces/RejectedSpacesPage";
import UsersPage from "@/pages/superadmin/users/UsersPage";

export default [
  {
    path: '/spaces/pending',
    name: 'SuperadminPendingSpacesPage',
    component: PendingSpacesPage,
    meta: {
      title: 'Urbnx | Web Dashboard - Pending Spaces'
    }
  },
  {
    path: '/spaces/created',
    name: 'SuperadminCreatedSpacesPage',
    component: CreatedSpacesPage,
    meta: {
      title: 'Urbnx | Web Dashboard - Created Spaces'
    }
  },
  {
    path: '/spaces/rejected',
    name: 'SuperadminRejectedSpacesPage',
    component: RejectedSpacesPage,
    meta: {
      title: 'Urbnx | Web Dashboard - Rejected Spaces'
    }
  },
  {
    path: '/spaces/active',
    name: 'SuperadminActiveSpacesPage',
    component: ActiveSpacesPage,
    meta: {
      title: 'Urbnx | Web Dashboard - Active Spaces'
    }
  },
  {
    path: '/accounting',
    name: 'SuperadminAccountingPage',
    component: AccountingPage,
    meta: {
      title: 'Urbnx | Web Dashboard - Accounting'
    }
  },
  {
    path: '/admin/bookings',
    name: 'SuperadminBookingsPage',
    component: BookingsPage,
    meta: {
      title: 'Urbnx | Web Dashboard - Bookings'
    }
  },
  {
    path: '/users',
    name: 'SuperadminUsersPage',
    component: UsersPage,
    meta: {
      title: 'Urbnx | Web Dashboard - Users'
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/superadmin.js